import { Services } from '@sigma-frontend-libs/commons'

import { buttonModes, components, states } from '@/utils'

import button from '@/components/button'
import buttonRefresh from '@/components/button/refresh'
import pagination from '@/components/pagination'
import preloader from '@/components/preloader'
import billingsDetailsItem from '@/components/services/billings/details/item'
import paymentsLog from '@/components/services/paymentLogs/template'
import filter from '@/components/services/payments/filter'
import item from '@/components/services/payments/item'

function renderRefreshButton(h) {
  return h(
    buttonRefresh,
    {
      props: {
        state: this.restData[Services.payments].find.state,
        shortClickMethod: () => {
          return this.rest[Services.payments].find()
        },
        longClickMethod: () => {
          return this.rest[Services.payments].find({}, { noCache: true })
        }
      }
    }
  )
}
function renderPagination(h) {
  return h(
    'div',
    {
      class: 'service-template-pagination'
    },
    [
      h(
        pagination,
        {
          props: {
            value: this.restData[Services.payments].find.pagination,
            service: Services.payments
          },
          on: {
            input: event => {
              this.restData[Services.payments].find.pagination = event
            }
          }
        }
      ),

      renderRefreshButton.call(this, h)
    ]
  )
}
function renderFilter(h) {
  return h(
    filter,
    {
      props: {
        value: this.restData[Services.payments].find.filter
      },
      on: {
        input: event => {
          this.restData[Services.payments].find.filter = event
        }
      }
    }
  )
}
function renderHeader(h) {
  return h(
    'div',
    {
      class: `${Services.payments}-list__header`
    },
    [
      renderFilter.call(this, h),
      renderPagination.call(this, h, true)
    ]
  )
}

function renderDivider(h) {
  if (this.restData[Services.payments].find.pagination.total > 0) {
    return h(components.divider)
  }
}

function renderPreloader(h) {
  return h(
    'div',
    {
      class: 'preloader__holder pa-5'
    },
    [ h(preloader) ]
  )
}
function renderAbsolutePreloader(h) {
  if (this.restData[Services.payments].find.state === states.loading) {
    return h(
      'div',
      {
        class: 'preloader__holder preloader__holder--absolute'
      },
      [ h(preloader) ]
    )
  }
}
function renderItem(h, value) {
  return h(
    item,
    {
      props: { value },
      key: value.id,
      on: {
        billings: event => {
          this.paymentsBillings = event
          this.showBillingsDialog = true
        },
        paymentLogs: event => {
          this.paymentId = event
          this.showPaymentLogsDialog = true
        }
      }
    }
  )
}
function renderItems(h) {
  return h(
    'div',
    {
      class: `${Services.payments}-list__items`
    },
    [
      this.restData[Services.payments].find.data.map(item => {
        return renderItem.call(this, h, item)
      }),

      renderAbsolutePreloader.call(this, h)
    ]
  )
}
function renderBody(h) {
  if (this.restData[Services.payments].find.pagination.total > 0) {
    return renderItems.call(this, h)
  } else {
    switch (this.restData[Services.payments].find.state) {
      case states.loading: return renderPreloader.call(this, h)
      case states.ready:
      default: return h(components.empty)
    }
  }
}

function renderPaymentLogsDialog(h) {
  if (this.canGetPaymentLogsAsAdmin) {
    return h(
      components.dialog,
      {
        props: {
          title: this.getTranslate(`${Services.payments}.titles.${Services.paymentLogs}`),
          value: this.showPaymentLogsDialog,
          maxWidth: 800
        },
        on: {
          input: event => {
            if (event === false) {
              this.paymentId = undefined
            }
            this.showPaymentLogsDialog = event
          }
        }
      },
      [
        h(
          paymentsLog,
          {
            props: {
              PaymentId: this.paymentId
            }
          }
        ),
        h(
          'div',
          {
            class: 'dialog__footer',
            slot: 'footer'
          },
          [
            h(
              button,
              {
                props: {
                  label: this.getTranslate('misc.buttons.close'),
                  mode: buttonModes.flat
                },
                on: {
                  click: () => {
                    this.showPaymentLogsDialog = false
                  }
                }
              }
            )
          ]
        )
      ]
    )
  }
}

function renderBillingsList(h) {
  if (Array.isArray(this.paymentsBillings) && this.paymentsBillings.length) {
    return this.paymentsBillings.map(value => {
      return h(
        billingsDetailsItem,
        {
          props: {
            value
          }
        }
      )
    })
  }
}
function renderBillingsDialog(h) {
  if (this.canGetPaymentsAsResellerUp) {
    return h(
      components.dialog,
      {
        props: {
          value: this.showBillingsDialog,
          title: this.getTranslate(`${Services.payments}.titles.${Services.billings}`),
          maxWidth: 1000
        },
        on: {
          input: event => {
            if (event === false) {
              this.paymentsBillings = []
            }
            this.showBillingsDialog = event
          }
        }
      },
      [
        renderBillingsList.call(this, h),

        h(
          'div',
          {
            class: 'dialog__footer',
            slot: 'footer'
          },
          [
            h(
              button,
              {
                props: {
                  label: this.getTranslate('misc.buttons.close'),
                  mode: buttonModes.flat
                },
                on: {
                  click: () => {
                    this.showBillingsDialog = false
                  }
                }
              }
            )
          ]
        )
      ]
    )
  }
}

export default function(h) {
  if (this.canGetPayments) {
    return h(
      'div',
      {
        class: `${Services.payments}-list`
      },
      [
        renderHeader.call(this, h),
        renderDivider.call(this, h),
        renderBody.call(this, h),
        renderPaymentLogsDialog.call(this, h),
        renderBillingsDialog.call(this, h)
      ]
    )
  }
}
